// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M14.7,2H6.5C5.7,2,5,2.7,5,3.5v17C5,21.3,5.7,22,6.5,22h11c0.8,0,1.5-0.7,1.5-1.5V6.3L14.7,2z M15,3.7L17.3,6h-1.8
		C15.2,6,15,5.8,15,5.5V3.7z M17.5,21h-11C6.2,21,6,20.8,6,20.5v-17C6,3.2,6.2,3,6.5,3H14v2.5C14,6.3,14.7,7,15.5,7H18v13.5
		C18,20.8,17.8,21,17.5,21z M8,9h8v1H8V9z M8,11h8v1H8V11z M8,13h4v1H8V13z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-file-fsLJd0Pg.js.map
